import { apiFetch } from '../../apiFetch'

export const getAdminBetaSignups = () =>
  apiFetch({ path: '/admin/beta_signups' })

export const postAdminBetaSignupInvite = (id) =>
  apiFetch({ method: 'POST', path: `/admin/beta_signups/${id}/invite`, payload: {} })

export const deleteAdminBetaSignupInvite = (id) =>
  apiFetch({ method: 'DELETE', path: `/admin/beta_signups/${id}/invite`, payload: {} })
